import { useState, createContext, useEffect } from 'react'
import { toast } from 'react-toastify'

import { useTableData } from '@/hooks/useTableData'

import { preparationService } from '@/services/Preparation/preparationService'
import { preparationServiceV2 } from '@/services/Preparation/v2/preparationService'
import { utilityService } from '@/services/Parametrization/utilityService'
import { providerService } from '@/services/Parametrization/providerService'
import { addressService } from '@/services/utils/addressService'
import { companyService } from '@/services/Parametrization/companyService'
import { utilityPreparationService } from '@/services/Preparation/utilityPreparationService'
import { productService } from '@/services/Parametrization/productService'
import { servicesParametrizationService } from '@/services/Parametrization/servicesParametrizationService'
import { categoryService } from '@/services/Parametrization/categoryService'
import { breakdownService } from '@/services/Parametrization/breakdownService'
import { vehicleService } from '@/services/utils/vehicleService'

import {
  IInsertPreparationServiceRequest,
  IUpdateIndividualPreparationServiceRequest,
  IUpdatePreparationServiceRequest,
} from '@/types/preparation.types'
import { CONSTANTS, SUCCESS_STATUS } from '@/utils/CONSTANTS'

interface IPreparation {
  children: React.ReactNode
}

type PreparationContextData = {
  PREPARATION_LIST: any
  INDICATORS_LIST: any
  MODEL_LIST: any
  MODEL_OPTIONS: any
  PROVIDER_LIST: any
  PROVIDER_OPTIONS: any
  STATE_LIST: any
  STATE_OPTIONS: any
  INTERPRISE_LIST: any
  INTERPRISE_OPTIONS: any
  OWNER_LIST: any
  OWNER_OPTIONS: any
  BOARD_LIST: any
  BOARD_OPTIONS: any
  CR_LIST: any
  CR_OPTIONS: any
  INSPECTION_LIST: any
  SERVICE_LIST: any
  ALL_SERVICES_LIST: any
  ALL_SERVICES_OPTIONS: any
  PRODUCT_LIST: any
  ALL_PRODUCTS_LIST: any
  ALL_PRODUCTS_OPTIONS: any
  BREAKDOWN_LIST: any
  BREAKDOWN_OPTIONS: any
  BREAKDOWN: any
  CATEGORY_LIST: any
  CATEGORY_OPTIONS: any
  FLEET_LIST: any
  SELECTED_BREAKDOW_LIST: any
  PREPARATION_DATA: any
  PREPARATION_SERVICE_DATA: any
  GET_INDICATORS: () => Promise<void>
  GET_PREPARATION: (params?: any, isFilterApplied?: boolean) => Promise<void>
  GET_INSPECTION: (params?: any, isFilterApplied?: boolean) => Promise<void>
  GET_SERVICES: (params?: any) => Promise<void>
  GET_ALL_SERVICES: (params?: any) => {}
  GET_PRODUCTS: (params?: any) => Promise<void>
  GET_ALL_PRODUCTS: (params?: any) => {}
  GET_BREAKDOWN: (params?: any) => Promise<void>
  GET_CATEGORY: (params?: any, isFilterApplied?: boolean) => {}
  GET_BREAKDOWN_LIST: (params?: any) => {}
  GET_FLEET: (params?: any) => {}
  GET_SELECTS: () => Promise<void>
  GET_SELECTED_BREAKDOWN: (params?: any) => Promise<void>
  GET_PROVIDER: (params?: any) => Promise<void>
  SET_SERVICE_LIST: (params: any) => void
  SET_PRODUCT_LIST: (params: any) => void
  UPDATE_PREPARATION_DATA: (value: any) => void
  CLEAR_PREPARATION_DATA: () => void
  CLEAR_ALL_PREPARATION: () => void
  SET_PREPARATION_SERVICE_DATA: (data: any) => void
  CREATE_PREPARATION: (data: any) => Promise<any>
  UPDATE_PREPARATION: (data: any) => Promise<any>
  UPDATE_PROVIDER: (data: any) => Promise<any>
  GET_BREAKDOWN_PHOTOS: (id: string) => Promise<any>
  CREATE_PREPARATION_SERVICE: (data: any) => void
  UPDATE_PREPARATION_SERVICE: (data: any) => void
  UPDATE_PREPARATION_SERVICES: (data: any) => void
}

export const PreparationContext = createContext({} as PreparationContextData)

export function PreparationProvider({ children }: IPreparation) {
  const [PREPARATION_LIST, SET_PREPARATION_LIST] = useState([])
  const [INDICATORS_LIST, SET_INDICATORS_LIST] = useState({})
  const [MODEL_LIST, SET_MODEL_LIST] = useState([])
  const [MODEL_OPTIONS, SET_MODEL_OPTIONS] = useState([])
  const [PROVIDER_LIST, SET_PROVIDER_LIST] = useState<any>({})
  const [PROVIDER_OPTIONS, SET_PROVIDER_OPTIONS] = useState([])
  const [STATE_LIST, SET_STATE_LIST] = useState([])
  const [STATE_OPTIONS, SET_STATE_OPTIONS] = useState([])
  const [INTERPRISE_LIST, SET_INTERPRISE_LIST] = useState<any>({})
  const [INTERPRISE_OPTIONS, SET_INTERPRISE_OPTIONS] = useState([])
  const [OWNER_LIST, SET_OWNER_LIST] = useState([])
  const [OWNER_OPTIONS, SET_OWNER_OPTIONS] = useState([])
  const [BOARD_LIST, SET_BOARD_LIST] = useState([])
  const [BOARD_OPTIONS, SET_BOARD_OPTIONS] = useState([])
  const [CR_LIST, SET_CR_LIST] = useState([])
  const [CR_OPTIONS, SET_CR_OPTIONS] = useState([])
  const [INSPECTION_LIST, SET_INSPECTION_LIST] = useState([])
  const [SERVICE_LIST, SET_SERVICE_LIST] = useState([])
  const [ALL_SERVICES_LIST, SET_ALL_SERVICES_LIST] = useState<any>([])
  const [ALL_SERVICES_OPTIONS, SET_ALL_SERVICES_OPTIONS] = useState([])
  const [PRODUCT_LIST, SET_PRODUCT_LIST] = useState([])
  const [ALL_PRODUCTS_LIST, SET_ALL_PRODUCTS_LIST] = useState<any>([])
  const [ALL_PRODUCTS_OPTIONS, SET_ALL_PRODUCTS_OPTIONS] = useState([])
  const [BREAKDOWN_LIST, SET_BREAKDOWN_LIST] = useState<any>([])
  const [BREAKDOWN_OPTIONS, SET_BREAKDOWN_OPTIONS] = useState([])
  const [BREAKDOWN, SET_BREAKDOWN] = useState([])
  const [CATEGORY_LIST, SET_CATEGORY_LIST] = useState<any>([])
  const [CATEGORY_OPTIONS, SET_CATEGORY_OPTIONS] = useState([])
  const [FLEET_LIST, SET_FLEET_LIST] = useState([])
  const [SELECTED_BREAKDOW_LIST, SET_SELECTED_BREAKDOWN_LIST] = useState([])
  const [PREPARATION_DATA, SET_PREPARATION_DATA] = useState({})
  const [PREPARATION_SERVICE_DATA, SET_PREPARATION_SERVICE_DATA] = useState(null)
  const { PER_PAGE, CURRENTE_PAGE, SORT_FIELD, SORT_ASCENDING } = useTableData()

  useEffect(() => {
    SET_DATA_SELECTS()
  }, [
    MODEL_LIST,
    PROVIDER_LIST,
    STATE_LIST,
    INTERPRISE_LIST,
    OWNER_LIST,
    BOARD_LIST,
    CR_LIST,
    CATEGORY_LIST,
    BREAKDOWN_LIST,
    ALL_SERVICES_LIST,
    ALL_PRODUCTS_LIST,
    SELECTED_BREAKDOW_LIST,
  ])

  async function GET_PREPARATION(params?: any, isFilterApplied?: boolean) {
    try {
      const res: any = await preparationService.get(
        PER_PAGE,
        CURRENTE_PAGE,
        SORT_FIELD.length ? SORT_FIELD : 'codigo',
        SORT_FIELD.length ? SORT_ASCENDING : false,
        params,
      )
      const preparations = res.data.data

      if (!preparations.rows.length) {
        SET_PREPARATION_LIST([])
        return toast.warning(CONSTANTS.filter.empty)
      }

      if (preparations.rows?.length && isFilterApplied) toast.success(CONSTANTS.filter.success)

      SET_PREPARATION_LIST(preparations)
      return preparations
    } catch (err) {
      toast.error('Não foi possível consultar os dados. Tente novamente.')
    }
  }

  async function GET_INSPECTION(params: any, isFilterApplied?: boolean) {
    try {
      const payload = {
        PageSize: PER_PAGE,
        Page: CURRENTE_PAGE,
        SortField: SORT_FIELD,
        SortAscending: SORT_ASCENDING,
        ...params,
      }
      const res: any = await preparationServiceV2.getInspections(payload)
      const inspections = res?.data?.data

      if (!inspections?.rows?.length) {
        SET_INSPECTION_LIST([])
        return toast.warning(CONSTANTS.filter.empty)
      }

      if (inspections?.rows?.length && isFilterApplied) toast.success(CONSTANTS.filter.success)

      SET_INSPECTION_LIST(inspections)
      return inspections
    } catch (err) {
      toast.error('Não foi possível consultar os dados. Tente novamente.')
    }
  }

  async function GET_INDICATORS() {
    if (Object.keys(INDICATORS_LIST).length) return

    try {
      const res: any = await preparationService.indicators()
      SET_INDICATORS_LIST(res.data.data)
      return res
    } catch (err) {
      toast.error('Não foi possível consultar os dados. Tente novamente.')
    }
  }

  async function GET_SERVICES(params: any) {
    try {
      const res: any = await preparationServiceV2.getServices(params)
      const services = res.data.data

      SET_SERVICE_LIST(services)
      return services
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function GET_ALL_SERVICES(params?: any) {
    try {
      const res: any = await servicesParametrizationService.get(params)
      const services = res.data.data

      SET_ALL_SERVICES_LIST(services)
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function GET_PRODUCTS(params: any) {
    try {
      const res: any = await preparationService.getProducts(params)
      const products = res.data.data

      SET_PRODUCT_LIST(products)
      return products
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function GET_ALL_PRODUCTS(params?: any) {
    try {
      const res: any = await productService.get(params)
      const products = res.data.data

      SET_ALL_PRODUCTS_LIST(products)
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function GET_BREAKDOWN(id: any) {
    try {
      const res: any = await preparationServiceV2.getBreakdown(id)
      const breakdowns = res.data.data
      SET_BREAKDOWN(breakdowns)
      return breakdowns
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function GET_BREAKDOWN_LIST(params: any) {
    try {
      const res: any = await breakdownService.get(params)
      SET_BREAKDOWN_LIST(res.data.data)
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function GET_SELECTED_BREAKDOWN(params?: any) {
    try {
      const res: any = await preparationService.getBreakdown(params)
      SET_SELECTED_BREAKDOWN_LIST(res.data.data)
      return res.data.data
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function GET_CATEGORY(params?: any, isFilterApplied?: boolean) {
    try {
      const res: any = await categoryService.get(params)
      const categories = res.data.data

      if (!categories?.rows?.length) return toast.warning(CONSTANTS.filter.empty)
      if (categories?.rows?.length && isFilterApplied) toast.success(CONSTANTS.filter.success)

      SET_CATEGORY_LIST(categories)
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function GET_FLEET(params?: any) {
    try {
      const res: any = await vehicleService.getFrota(params)
      SET_FLEET_LIST(res.data.data)
    } catch (err) {
      toast.error('Não foi possível consultar os dados. Tente novamente.')
    }
  }

  async function GET_PROVIDER(params?: any) {
    try {
      const res: any = await providerService.get({ ativo: true, PageSize: 0 })
      SET_PROVIDER_LIST(res?.data?.data)
      return res.data.data
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function GET_SELECTS() {
    if (
      MODEL_LIST.length &&
      PROVIDER_LIST?.rows?.length &&
      STATE_LIST.length &&
      INTERPRISE_LIST?.rows?.length &&
      OWNER_LIST.length &&
      BOARD_LIST.length &&
      CR_LIST.length
    )
      return null
    try {
      const res: any = await Promise.all([
        utilityService.getModel({ ativo: true }),
        providerService.get({ ativo: true, PageSize: 0 }),
        addressService.getStates(),
        companyService.get({}),
        utilityPreparationService.getOwner(),
        utilityPreparationService.getBoard(),
        utilityPreparationService.getResultCenter(),
      ])
      SET_MODEL_LIST(() => res[0].data.data)
      SET_PROVIDER_LIST(() => res[1].data.data)
      SET_STATE_LIST(() => res[2].data.data)
      SET_INTERPRISE_LIST(() => res[3].data.data)
      SET_OWNER_LIST(() => res[4].data.data)
      SET_BOARD_LIST(() => res[5].data.data)
      SET_CR_LIST(() => res[6].data.data)
      return res
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function SET_DATA_SELECTS() {
    let arrOfModels: any = []
    let arrOfProviders: any = []
    let arrOfStates: any = []
    let arrOfInterprise: any = []
    let arrOfOwner: any = []
    let arrOfBoard: any = []
    let arrOfCr: any = []
    let arrOfCategories: any = []
    let arrOfBreakdowns: any = []
    let arrOfServices: any = []
    let arrOfPRoducts: any = []

    MODEL_LIST.forEach((item: any) => {
      arrOfModels.push(`${item?.nome} - ${item?.codigoFipe}`)
    })
    PROVIDER_LIST?.rows?.forEach((item: any) => {
      arrOfProviders.push(item?.nomeResponsavel)
    })
    STATE_LIST.forEach((item: any) => {
      arrOfStates.push(item?.nome)
    })
    INTERPRISE_LIST?.rows?.forEach((item: any) => {
      arrOfInterprise.push(item?.nomeFantasia)
    })
    OWNER_LIST.forEach((item: any) => {
      arrOfOwner.push(item?.nome)
    })
    BOARD_LIST.forEach((item: any) => {
      arrOfBoard.push(item?.descricao)
    })
    CR_LIST.forEach((item: any) => {
      arrOfCr.push(item?.descricao)
    })
    CATEGORY_LIST?.rows?.forEach((item: any) => {
      arrOfCategories.push(item?.nome)
    })
    BREAKDOWN_LIST?.rows?.forEach((item: any) => {
      arrOfBreakdowns.push(item?.nome)
    })
    ALL_SERVICES_LIST?.rows?.forEach((item: any) => {
      arrOfServices.push(item?.nome)
    })
    ALL_PRODUCTS_LIST?.rows?.forEach((item: any) => {
      arrOfPRoducts.push(item?.nome)
    })

    await SET_MODEL_OPTIONS(arrOfModels)
    await SET_PROVIDER_OPTIONS(arrOfProviders)
    await SET_STATE_OPTIONS(arrOfStates)
    await SET_INTERPRISE_OPTIONS(arrOfInterprise)
    await SET_OWNER_OPTIONS(arrOfOwner)
    await SET_BOARD_OPTIONS(arrOfBoard)
    await SET_CR_OPTIONS(arrOfCr)
    await SET_CATEGORY_OPTIONS(arrOfCategories)
    await SET_BREAKDOWN_OPTIONS(arrOfBreakdowns)
    await SET_ALL_SERVICES_OPTIONS(arrOfServices)
    await SET_ALL_PRODUCTS_OPTIONS(arrOfPRoducts)
  }

  function UPDATE_PREPARATION_DATA(value: any) {
    SET_PREPARATION_DATA((prevState) => ({ ...prevState, ...value }))
  }

  function CLEAR_PREPARATION_DATA() {
    SET_PREPARATION_DATA({})
  }

  function CLEAR_ALL_PREPARATION() {
    SET_PREPARATION_DATA({})
    SET_INSPECTION_LIST([])
    SET_BREAKDOWN([])
    SET_SELECTED_BREAKDOWN_LIST([])
  }

  async function CREATE_PREPARATION(params: any) {
    try {
      const responseCreate = await preparationService.post(params)
      return responseCreate
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  async function UPDATE_PREPARATION(params: any) {
    try {
      const responseUpdate = await preparationServiceV2.putInspection(params)
      return responseUpdate
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  async function UPDATE_PROVIDER(params: any) {
    try {
      const responseUpdate = await preparationService.putProvider(params)
      return responseUpdate
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  const GET_BREAKDOWN_PHOTOS = async (id: string) => {
    try {
      const responseInspectionPhotos = await preparationServiceV2.getBreakdown(id)
      if (SUCCESS_STATUS.includes(responseInspectionPhotos.status)) {
        return responseInspectionPhotos?.data?.data
      }
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  const CREATE_PREPARATION_SERVICE = async (data: IInsertPreparationServiceRequest) => {
    try {
      return await preparationServiceV2.postService(data)
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  const UPDATE_PREPARATION_SERVICE = async (data: IUpdateIndividualPreparationServiceRequest) => {
    try {
      return await preparationServiceV2.putIndividualService(data)
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  const UPDATE_PREPARATION_SERVICES = async (data: IUpdatePreparationServiceRequest) => {
    try {
      return await preparationServiceV2.putService(data)
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  return (
    <PreparationContext.Provider
      value={{
        PREPARATION_LIST,
        INDICATORS_LIST,
        MODEL_LIST,
        MODEL_OPTIONS,
        PROVIDER_LIST,
        PROVIDER_OPTIONS,
        STATE_LIST,
        STATE_OPTIONS,
        INTERPRISE_LIST,
        INTERPRISE_OPTIONS,
        OWNER_LIST,
        OWNER_OPTIONS,
        BOARD_LIST,
        BOARD_OPTIONS,
        CR_LIST,
        CR_OPTIONS,
        INSPECTION_LIST,
        SERVICE_LIST,
        PRODUCT_LIST,
        BREAKDOWN,
        BREAKDOWN_LIST,
        BREAKDOWN_OPTIONS,
        CATEGORY_LIST,
        CATEGORY_OPTIONS,
        ALL_SERVICES_LIST,
        ALL_SERVICES_OPTIONS,
        ALL_PRODUCTS_LIST,
        ALL_PRODUCTS_OPTIONS,
        FLEET_LIST,
        SELECTED_BREAKDOW_LIST,
        PREPARATION_DATA,
        PREPARATION_SERVICE_DATA,
        GET_SELECTED_BREAKDOWN,
        GET_ALL_PRODUCTS,
        GET_ALL_SERVICES,
        GET_CATEGORY,
        GET_BREAKDOWN,
        GET_BREAKDOWN_LIST,
        GET_PRODUCTS,
        GET_SERVICES,
        GET_PREPARATION,
        GET_INDICATORS,
        GET_SELECTS,
        GET_INSPECTION,
        GET_FLEET,
        GET_PROVIDER,
        SET_SERVICE_LIST,
        SET_PRODUCT_LIST,
        UPDATE_PREPARATION_DATA,
        CLEAR_PREPARATION_DATA,
        CLEAR_ALL_PREPARATION,
        SET_PREPARATION_SERVICE_DATA,
        CREATE_PREPARATION,
        UPDATE_PREPARATION,
        UPDATE_PROVIDER,
        GET_BREAKDOWN_PHOTOS,
        CREATE_PREPARATION_SERVICE,
        UPDATE_PREPARATION_SERVICE,
        UPDATE_PREPARATION_SERVICES,
      }}
    >
      {children}
    </PreparationContext.Provider>
  )
}
